export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contrats"])},
        "compliant": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conforme"])},
        "non_compliant": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non conforme"])},
        "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier"])},
        "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Résilier"])},
        "cancelled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contrat résilié"])},
        "send_confirmation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer le mail de confirmation"])},
        "send_confirmation_prompt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer le mail de confirmation de souscription ?"])},
        "email_sent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email envoyé"])},
        "updated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contrat modifié"])},
        "tab_customer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Client"])},
        "tab_products": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Produits"])},
        "tab_retributions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primes"])},
        "tab_payments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paiements"])}
      },
      "en": {
        "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contracts"])},
        "compliant": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compliant"])},
        "non_compliant": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non compliant"])},
        "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Update"])},
        "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel the contract"])},
        "cancelled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contract cancelled"])},
        "send_confirmation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send the confirmation email"])},
        "send_confirmation_prompt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send the subscription confirmation email?"])},
        "email_sent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email sent"])},
        "updated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contract updated"])},
        "tab_customer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Customer"])},
        "tab_products": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Products"])},
        "tab_retributions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Commissions"])},
        "tab_payments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Payments"])}
      }
    }
  })
}
